<template>
  <div class="blogShare">
    <div class="blogShare__text">Udostępnij post:</div>
    <ul class="blogShare__list">
      <li class="blogShare__item">
        <a
          :href="`http://www.facebook.com/sharer.php?u=${$config.baseUrl}${$route.fullPath}`"
          class="blogShare__link blogShare__link--facebook"
          rel="noopener noreferrer nofollow"
          target="_blank"
        />
      </li>
      <li class="blogShare__item">
        <a
          :href="`http://twitter.com/home?status=Reading:${$config.baseUrl}${$route.fullPath}`"
          class="blogShare__link blogShare__link--twitter"
          rel="noopener noreferrer nofollow"
          target="_blank"
          title="Share this post on Twitter!"
        />
      </li>
      <li class="blogShare__item">
        <a
          :href="`http://www.linkedin.com/shareArticle?mini=true&amp;url=${$config.baseUrl}${$route.fullPath}&amp;source=${$config.baseUrl}`"
          class="blogShare__link blogShare__link--linkedin"
          rel="noopener noreferrer nofollow"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BlogShare',
};
</script>

<style lang="scss">
.blogShare {
  display: flex;
  align-items: center;

  &__text {
    font-size: 1.4rem;
    line-height: 2.4rem;
    color: $cAddDark02;
    padding-right: 2.5rem;
  }

  &__list {
    display: flex;
    margin: 0 -0.5rem;
  }

  &__item {
    padding: 0 0.5rem;
  }

  &__link {
    display: flex;
    width: 4rem;
    height: 4rem;
    align-items: center;
    justify-content: center;
    background-color: rgba($cAddDark, 0.1);
    border-radius: 50%;
    color: $cMain;
    font-size: 1.4rem;
    transition: color $tr;

    &--facebook {
      &:before {
        @include icomoon('facebook');
      }
    }

    &--linkedin {
      &:before {
        @include icomoon('linkedin');
      }
    }

    &--twitter {
      &:before {
        @include icomoon('twitter');
      }
    }

    &:hover {
      color: $cSec;
    }
  }
}
</style>
